/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap')

import Vue from 'vue'

window.Vue = Vue;

Vue.prototype.$inventoryEnabled = true;

// SweetAlerts 2
import VueSweetalert2 from 'vue-sweetalert2';
const SwalOptions = {
    confirmButtonColor: '#035980',
    cancelButtonColor: '#999',
    cancelButtonText: 'Nej',
    backdrop: 'rgba(0, 0, 0, 0.4)',
};

Vue.use(VueSweetalert2, SwalOptions);

//Buefy
import { ConfigProgrammatic, Tabs, Pagination, Skeleton, Table, Icon, Tooltip, Select, Loading, Dropdown, Button, Switch, Collapse } from 'buefy'

Vue.use(Pagination)
Vue.use(Skeleton)
Vue.use(Table)
Vue.use(Icon)
Vue.use(Tabs)
Vue.use(Tooltip)
Vue.use(Select)
Vue.use(Loading)
Vue.use(Dropdown)
Vue.use(Button)
Vue.use(Switch)
Vue.use(Collapse)

ConfigProgrammatic.setOptions({
    defaultIconPack: 'fas',
})

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

Vue.component('app', require('./App.vue').default)

Vue.directive('focus', {
    inserted: function (el) {
        el.focus();
    }
})

import store from './store'
import router from './router'

const app = new Vue({
    el: '#app',
    store,
    router,
})
